import { render, staticRenderFns } from "./SingleLienholder.vue?vue&type=template&id=f95f3f3e&scoped=true&"
import script from "./SingleLienholder.vue?vue&type=script&lang=js&"
export * from "./SingleLienholder.vue?vue&type=script&lang=js&"
import style0 from "./SingleLienholder.vue?vue&type=style&index=0&id=f95f3f3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95f3f3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCombobox,VDialog,VIcon,VTextField})
